import { RouterProvider, createBrowserRouter, createHashRouter } from "react-router-dom";
import Layout from "../Layout/Layout.jsx";
import About from "../About/About.jsx";
import Contact from "../Contact/Contact.jsx";
import Home from "../Home/Home.jsx";
import NotFoundPage from "../NotFoundPage/NotFoundPage.jsx";
import Blogs from "../Blogs/Blogs.jsx";
import SingleBlog from "../SingleBlog/SingleBlog.jsx";
import Projects from "../Projects/Projects.jsx";
import Services from "../Services/Services.jsx";
function App() {

  const routes = createBrowserRouter([
    {
      path: '/', element: <Layout />, children: [
        { index: true, element: <Home /> },
        { path: '/about', element: <About /> },
        { path: '/contact', element: <Contact /> },
        { path: '/blogs', element: <Blogs /> },
        { path: '/projects', element: <Projects /> },
        { path: '/services', element: <Services /> },
        { path: '/blogs/:blogId', element: <SingleBlog /> },
        { path: '*', element: <NotFoundPage /> },
      ]
    }
  ])

  return (
    <div className="App overflow-hidden">
      <RouterProvider router={routes} />
    </div>
  );
}

export default App;
